/*
    BEEP BOP BOOP - I AM AN AUTO GENERATED FILE - DO NOT EDIT ME MANUALLY
*/


// Name: Service Constants 

// DepositState
export const DEPOSIT_STATE_PENDING = 'pending';
export const DEPOSIT_STATE_ACTIVE = 'active';
export const DEPOSIT_STATE_CLOSE_REQUESTED = 'close_requested';
export const DEPOSIT_STATE_CLOSED = 'closed';
export const DEPOSIT_STATE_DISPUTED = 'disputed';
export const DEPOSIT_STATE_DISPUTE_SPLIT_PROPOSED = 'dispute_split_proposed';
export const DEPOSIT_STATE_MEDIATOR_INVOLVED_DISPUTE = 'mediator_involved_dispute';
export const DEPOSIT_STATE_MEDIATOR_SPLIT_PROPOSED = 'mediator_split_proposed';
export const DEPOSIT_STATE_CANCELLED = 'cancelled';

// DepositAccountType
export const DEPOSIT_ACCOUNT_TYPE_LANDLORD = 'landlord';
export const DEPOSIT_ACCOUNT_TYPE_TENANT = 'tenant';
export const DEPOSIT_ACCOUNT_TYPE_MEDIATOR = 'mediator';

// PropertyType
export const PROPERTY_TYPE_APARTMENT = 'apartment';
export const PROPERTY_TYPE_UNIT = 'unit';
export const PROPERTY_TYPE_APARTMENT_BUILDING = 'apartment_building';
export const PROPERTY_TYPE_APARTMENT_BUILDING_FLOOR = 'apartment_building_floor';
export const PROPERTY_TYPE_HOUSE = 'house';
export const PROPERTY_TYPE_BUILDING = 'building';
export const PROPERTY_TYPE_BUILDING_FLOOR = 'building_floor';
export const PROPERTY_TYPE_ROOM = 'room';
export const PROPERTY_TYPE_TOWNHOUSE = 'townhouse';
export const PROPERTY_TYPE_CITY = 'city';
export const PROPERTY_TYPE_DISTRICT = 'district';
export const PROPERTY_TYPE_COMMUNITY = 'community';
export const PROPERTY_TYPE_GATED_COMMUNITY = 'gated_community';
export const PROPERTY_TYPE_HOUSING_ESTATE = 'housing_estate';
export const PROPERTY_TYPE_DORMITORY = 'dormitory';
export const PROPERTY_TYPE_DORMITORY_UNIT = 'dormitory_unit';
export const PROPERTY_TYPE_DUPLEX = 'duplex';
export const PROPERTY_TYPE_DUPLEX_UNIT = 'duplex_unit';
export const PROPERTY_TYPE_SUITE = 'suite';
export const PROPERTY_TYPE_CABIN = 'cabin';
export const PROPERTY_TYPE_CHALET = 'chalet';
export const PROPERTY_TYPE_COTTAGE = 'cottage';
export const PROPERTY_TYPE_RETIREMENT_COMMUNITY = 'retirement_community';
export const PROPERTY_TYPE_VILLA = 'villa';
export const PROPERTY_TYPE_ASSISTED_LIVING = 'assisted_living';
export const PROPERTY_TYPE_VILLAGE = 'village';
export const PROPERTY_TYPE_PROPERTY = 'property';

// List DepositState
export const ALL_DEPOSIT_STATE_VALUES = [
    DEPOSIT_STATE_PENDING,
    DEPOSIT_STATE_ACTIVE,
    DEPOSIT_STATE_CLOSE_REQUESTED,
    DEPOSIT_STATE_CLOSED,
    DEPOSIT_STATE_DISPUTED,
    DEPOSIT_STATE_DISPUTE_SPLIT_PROPOSED,
    DEPOSIT_STATE_MEDIATOR_INVOLVED_DISPUTE,
    DEPOSIT_STATE_MEDIATOR_SPLIT_PROPOSED,
    DEPOSIT_STATE_CANCELLED
];

// List PropertyType
export const ALL_PROPERTY_TYPE_VALUES = [
    PROPERTY_TYPE_APARTMENT,
    PROPERTY_TYPE_UNIT,
    PROPERTY_TYPE_APARTMENT_BUILDING,
    PROPERTY_TYPE_APARTMENT_BUILDING_FLOOR,
    PROPERTY_TYPE_HOUSE,
    PROPERTY_TYPE_BUILDING,
    PROPERTY_TYPE_BUILDING_FLOOR,
    PROPERTY_TYPE_ROOM,
    PROPERTY_TYPE_TOWNHOUSE,
    PROPERTY_TYPE_CITY,
    PROPERTY_TYPE_DISTRICT,
    PROPERTY_TYPE_COMMUNITY,
    PROPERTY_TYPE_GATED_COMMUNITY,
    PROPERTY_TYPE_HOUSING_ESTATE,
    PROPERTY_TYPE_DORMITORY,
    PROPERTY_TYPE_DORMITORY_UNIT,
    PROPERTY_TYPE_DUPLEX,
    PROPERTY_TYPE_DUPLEX_UNIT,
    PROPERTY_TYPE_SUITE,
    PROPERTY_TYPE_CABIN,
    PROPERTY_TYPE_CHALET,
    PROPERTY_TYPE_COTTAGE,
    PROPERTY_TYPE_RETIREMENT_COMMUNITY,
    PROPERTY_TYPE_VILLA,
    PROPERTY_TYPE_ASSISTED_LIVING,
    PROPERTY_TYPE_VILLAGE,
    PROPERTY_TYPE_PROPERTY
];


// Constants
export const DEPOSITS_SERVICE_VALUE_ERROR_EMAIL_ALREADY_IN_USE_FOR_INVITE = 'email_already_in_use_for_invite';

